import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 591,
  background: theme.palette.custom.primary,
  padding: "24px",
  borderRadius: theme.borderRadius.radius.large,
  color: theme.palette.custom.white,
  outline: "none",

  [theme.breakpoints.down("md")]: {
    width: 530,
  },
  [theme.breakpoints.down("sm")]: {
    width: 350,
  },
  [theme.breakpoints.down("xs")]: {
    width: 270,
  },
}));

export const ModalHeader = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
}));
export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.xLarge.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  paddingTop: "24px",

  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.large.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.regular.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const ModalDescription = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.mini.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.tiny.fontSize,
  },

  paddingTop: "12px",
}));
export const ButtonWrapper = styled(Box)(() => ({
  paddingTop: "24px",
  width: "141px",
}));
export const CloseBtn = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  cursor: "pointer",
}));
